import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1];

const AnimatedSection = ({ children, delay = 0, duration = 1.0, className = '' }) => {
    const prefersReducedMotion = useReducedMotion();

    if (prefersReducedMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration, delay, ease: EASE_OUT_EXPO }}
        >
            {children}
        </motion.div>
    );
};

export default AnimatedSection;
